/**
 * Colorways are separate products linked by the Linkify Product Colors app, which switches color with
 * `window.location.href = ...` and so adds a history entry per color. Intercept those swatch clicks and
 * navigate with `location.replace()` instead, so the browser back button skips the colorway changes
 * and returns to the page the customer was on before opening the product.
 */
(function () {
  'use strict';

  // Only the main product's swatches; product cards elsewhere on the page keep normal navigation.
  var SCOPE_SELECTOR = '.product__info-container';
  var SWATCH_SELECTOR = 'linkify-product-colors-swatch[data-handle], .swatchProductColor[data-handle]';

  function isInactive(swatch) {
    // Current color, or sold out/unavailable: leave it to the app, which ignores these clicks.
    return (
      swatch.hasAttribute('data-selected') ||
      swatch.hasAttribute('data-soldout') ||
      swatch.classList.contains('currentSwatch') ||
      swatch.classList.contains('swatchUnavailable')
    );
  }

  // Same URL the app builds: keep a locale/collection prefix such as /fr/collections/knit/products/...
  function getColorUrl(handle) {
    var prefix = window.location.pathname.match(/^((\/[a-z0-9_-]{1,8})?(\/collections\/[a-z0-9-]+)?)\/products\//i);
    return (prefix ? prefix[1] : '') + '/products/' + encodeURIComponent(handle);
  }

  document.addEventListener(
    'click',
    function (event) {
      var swatch = event.target.closest && event.target.closest(SWATCH_SELECTOR);
      if (!swatch || !swatch.closest(SCOPE_SELECTOR) || isInactive(swatch)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.replace(getColorUrl(swatch.getAttribute('data-handle')));
    },
    true
  );
})();
